import template from './sessions.html';

class ProfileSessionsTabComponentVM
{
	constructor(params)
	{
		this.vm = params.vm;
		this.uuid = ko.observable('');
		this.sessions = ko.observableArray([]);
		this.state = ko.observable('view');
		this.status_message = ko.observable('');
		this.vm.user_data.subscribe((user) => {
			this.uuid(user?.uuid || '');
			if (this.vm.selected_tab() == 'sessions')
				this.load_sessions();
		});

		if (this.vm.user_data())
			this.uuid(this.vm.user_data()?.uuid || '');
		this.vm.selected_tab.subscribe((selectedTab) => {
			if (selectedTab == 'sessions')
				this.load_sessions();
		});

		if (this.vm.selected_tab() == 'sessions')
			this.load_sessions();
	}

	async load_sessions ()
	{
		this.state('loading');
		this.status_message('Loading sessions...');
		if (!this.uuid())
		{
			this.sessions([]);
			this.state('view');
			return;
		}

		try {
			const session_data = await Grape.fetches.getJSON('/api/record', {
				table: 'v_active_sessions',
				schema: 'grape',
				filter: [{ field: 'user_uuid', operator: '=', value: this.uuid() }]
			});
			if (session_data.status == 'ERROR')
				throw new Error(session_data.message || session_data.code || 'Failed to load sessions');

			this.sessions(Array.isArray(session_data.records) ? session_data.records : []);
			this.state('view');
		} catch (error) {
			this.state('error');
			this.status_message(error.message);
			this.sessions([]);
		}
	}

	async end_session_click (row)
	{
		const result = await Grape.fetches.getJSON('/api/session/logout', { session_uuid: row.session_uuid });
		if (result?.status == 'ERROR')
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: result.message || 'Failed to end session' });
			return;
		}

		if (Grape.currentSession.session_uuid == row.session_uuid)
			Grape.navigate('/ui/logout');
		else
			await this.load_sessions();
	}
}

export default {
	name: 'profile-sessions-tab',
	viewModel: ProfileSessionsTabComponentVM,
	module_type: 'ko',
	template: template
};
